/**
 * Generate a set of key value pairs to from the specified mapper
 */
export function getMappedKeyValues(mapper) {
    const keysValues = [];
    for (const key in mapper) {
        const value = mapper[key]();
        if (value !== undefined && value !== null) {
            keysValues.push({ key: key, value: value });
        }
    }
    return keysValues;
}
/**
 * Generate an object from the mapper
 */
export function buildMappedValueObject(mapper) {
    const result = {};
    for (const key in mapper) {
        const fn = mapper[key];
        const value = fn !== undefined ? fn() : undefined;
        if (value !== undefined && value !== null) {
            result[key] = value;
        }
    }
    return result;
}
/**
 * Add params to a url based on values retrieved from the supplied mapper
 */
export function decorateUrlUsingMapper(subjectUrl, mapper) {
    if (subjectUrl === undefined) {
        return '';
    }
    const decorated = new URL(subjectUrl);
    // Get existing params from component's href attribute
    const params = new URLSearchParams(decorated.search);
    const values = getMappedKeyValues(mapper);
    // Add our new params to the set
    for (const { key, value } of values) {
        if (params.get(key) === null && value.length > 0) {
            // exclude empty-valued params and do not overwrite existing keys
            params.append(key, value);
        }
    }
    // Return the original URL but with extra params
    const queryParams = [];
    params.forEach((value, key) => {
        queryParams.push(`${key}=${encodeURIComponent(value)}`);
    });
    return `${decorated.protocol}//${decorated.host}${decorated.pathname}?${queryParams.join('&')}`;
}
//# sourceMappingURL=keyValueMappers.js.map